import { useCallback, useEffect, useState } from 'react'
import {
  ApiErrorResponse,
  getAppClient,
  handleError,
} from '../../../utils/network_util'
import { EnterpriseRanking } from '../../../model/Ranking'
import { useSnackBar } from '../../../providers/snack_bar_provider'
import { INDUSTRY_CODE } from '../../../constants/codes'

type IndustryRankingData = {
  industryCode: string
  industryName: string
  rankings: Array<EnterpriseRanking>
}

type UseIndustryRankingProps = {
  getLimit?: number
}

const useIndustryRanking = (
  props: UseIndustryRankingProps
): [Array<IndustryRankingData>, boolean] => {
  const limit = props.getLimit || 5
  const apiClient = getAppClient()

  const { showSnackBar } = useSnackBar()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [industryRankings, setIndustryRankings] = useState<
    Array<IndustryRankingData>
  >([])

  const loadIndustryRankings = useCallback(async () => {
    setIsLoading(true)

    try {
      // 全業種のランキングを一括取得
      const res = await apiClient.ranking.industriesList({
        limit: limit,
      })

      const data = res.data.data as Array<IndustryRankingData>
      setIndustryRankings(data)
    } catch (e) {
      handleError(e as ApiErrorResponse, showSnackBar)
    } finally {
      setIsLoading(false)
    }
  }, [limit, apiClient, showSnackBar])

  useEffect(() => {
    loadIndustryRankings()
  }, [])

  return [industryRankings, isLoading]
}

export default useIndustryRanking
